export default __webpack_public_path__ + "static/media/VNIT_logo.8bd49ba3.jpeg";